var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-496.000000, -65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(336.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    transform: "translate(13.353500, 20.448625) scale(-1, 1) rotate(135.000000) translate(-13.353500, -20.448625) ",
    points: "18.6577945 15.1443304 11.6577945 15.1443304 11.6577945 17.1443304 15.2437945 17.1443304 8.04920547 24.3389194 9.46320547 25.7529194 16.6577945 18.5583304 16.6577945 22.1443304 18.6577945 22.1443304"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    transform: "translate(19.304295, 11.501405) scale(-1, -1) rotate(135.000000) translate(-19.304295, -11.501405) ",
    points: "24.6085891 6.19711073 17.6085891 6.19711073 17.6085891 8.19711073 21.1945891 8.19711073 14 15.3916998 15.414 16.8056998 22.6085891 9.61111073 22.6085891 13.1971107 24.6085891 13.1971107"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/Reverse.71fd137a.svg";
export { ForwardRef as ReactComponent };